<!-- amazon-button-page.component.html -->
<!-- Page banner Area -->
<div class="page-banner bg-1">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-content service-banner-content">
                    <h2>Authorization</h2>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End Page banner Area -->

<div class="main container-fluid py-4 py-lg-5">
    <div class="container-fluid px-lg-5">
        <div class="row g-4 align-items-stretch">
            <div class="col-12">
                <div class="left h-100">
                    <div class="heading">
                        <span class="heading-accent">Guide</span>
                        <span>Steps To Integrate Amazon</span>
                    </div>
                    <div class="left-content">
                        <span>For Developer's Access:</span>
                        <div class="time-chart ui-widget playbook-panel">
                            <!-- <h3 class="start">Journey Begins</h3> -->
                            <ul class="timeline">
                                <li>&nbsp;</li>
                                <li>
                                    <!-- <div class="event">New Product Launch</div> -->
                                    <p class="description ">Note: Lemonmode does not pull "EASYSHIP" orders as they are
                                        fulfilled by
                                        Amazon Transport Services (ATS). They can be
                                        processed and shipped on Amazon Seller central only.</p>
                                </li>
                                <li class="green">
                                    <!-- <div class="event">New York Times</div> -->
                                    <p class="description ">To proceed, please click on the "AMAZON” button on your
                                        screen.</p>
                                </li>
                                <li class="green">
                                    <!-- <div class="event">New York Times</div> -->
                                    <p class="description ">Select your marketplace that you want to integrate, and
                                        click on the
                                        "Connect to
                                        AMAZON” button.</p>
                                </li>
                                <li class="green">
                                    <!-- <div class="event">New York Times</div> -->
                                    <p class="description ">You'll be diverted to the Amazon seller central login page.
                                        Log in to your
                                        Amazon account by entering your username and
                                        password.</p>
                                </li>
                                <li class="green">
                                    <!-- <div class="event">New York Times</div> -->
                                    <p class="description ">Once logged in, a page ‘Authorise Online Adda Selling
                                        Partner’ will open
                                        where you can verify your account integration
                                        with lemonmon by clicking “Confirm”.</p>
                                </li>
                                <li class="green">
                                    <!-- <div class="event">New York Times</div> -->
                                    <p class="description ">Now, you will be redirected to the Lemonmode page. Here you
                                        can import order
                                        files and track as per
                                        your preferences.</p>
                                </li>
                                <li>&nbsp;</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="Right h-100">
                    <!-- button -->
                    <div class="text-center right-panel-intro">
                        <div class="right-panel-copy">
                            <div class="right-kicker">Marketplace Setup</div>
                            <div class="text-custom">Select Your first marketplace</div>
                            <div class="right-heading2">Click the Amazon button for dynamic order fulfillment and
                                increased
                                sales!</div>
                        </div>
                        <hr class="right-divider" />
                        <div class="amazon-trigger-shell">
                            <div class="amazon-trigger-glow"></div>
                            <div class="amazon-image" (click)="toggleOpened()">
                                <img
                                    src="https://api.freelogodesign.org/assets/blog/img/20180911090509731amazon_logo_RGB.jpg">
                            </div>
                        </div>
                    </div>

                    <!--start all country -->
                    <div class="Divmain d-flex flex-column align-items-center justify-content-center"
                        *ngIf="amazonButtonClicked">
                        <div class="marketplace-stage">
                            <div class="marketplace-stage__header">
                                <div class="right-heading3">And which channel would you like to try tracking On first ?
                                </div>
                                <span class="channel-note">Select the option below <i
                                        class='bx bx-down-arrow-alt'></i></span>
                            </div>
                            <div class="wrapper marketplace-wrapper">
                                <div class="AllCountry">
                                    <div class="popCountry"
                                        [ngClass]="{ selected: selectedCountry === allMarketplace.countryCode }"
                                        (click)="selectedCountry = allMarketplace.countryCode"
                                        *ngFor="let allMarketplace of allMarketplaces">
                                        <div class="popCountry__inner">
                                            <img class="image"
                                                src="https://images.unsplash.com/photo-1597058712635-3182d1eacc1e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1374&q=80" />
                                            <span class="countryName">{{IND }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- end countries div -->

                    <!-- start authorization -->
                    <div>
                        <div class="text-center footer-button" *ngIf="selectedCountry">
                            <button class="default-btn-one amazon-connect-btn" (click)="redirectToMarketplace()">Connect to AMAZON <i
                                    class='bx bx-right-arrow-alt' style="font-size: 24px;"></i></button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- end authorization -->
        </div>
    </div>
</div>
